  
$(document).ready(function(){
 // Modal popup script
  $(".open_popup").click(function () {
    $(this).parent(".popup_main").children(".popup_body").addClass("popup_body_show");
     $("body").css("overflow", "hidden");
  });
  $(".popup_close").click(function () {
    $(".popup_body").removeClass("popup_body_show");
     $("body").css("overflow", "unset");
  });
  $(".popup_back").click(function () {
    $(".popup_body").removeClass("popup_body_show");
     $("body").css("overflow", "unset");
  });
  
   // Team page show more functionlity  
  var count = 1;
  $(document).on("click",".team-wrapper .button-load",function(){
    var lastChildGroup = parseInt($(".team-box:last-child").attr("data-group"));
  	count += 1;
    $(".team-box.box-group-"+count).addClass("show-box");
    if(count == lastChildGroup){
      $(this).hide();
    }
  });
  
});